var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ts-page-title',{attrs:{"title":_vm.$t('eod.pageTitle'),"breadcrumb":[
            { text: _vm.$t('home'), href: '/' },
            {
                text: _vm.$t('eod.pageTitle'),
                active: true
            }
        ]}}),_c('ts-panel',[_c('Tabs',{on:{"on-click":_vm.changeTab}},[_c('TabPane',{attrs:{"label":"EoD Process","icon":"ios-analytics-outline"}},[_c('eod-process',{ref:"eod_process"})],1),_c('TabPane',{attrs:{"label":"Rollback History","icon":"ios-timer-outline"}},[_c('rollback-history',{ref:"rollback_history"})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }